export type ModalMode = 'modal' | 'alert' | 'dialog' | 'confirmation'

export const ALERT_MODE: ModalMode = 'alert'
export const CONFIRMATION_MODE: ModalMode = 'confirmation'
export const DIALOG_MODE: ModalMode = 'dialog'
export const MODAL_MODE: ModalMode = 'modal'
